import { Typography, Grid } from "@mui/material";

/**
 * LoanProcessingStatusOld Component
 * Displays a visual representation of loan processing progress as old journey
 *
 * @param {boolean} alreadySubmitted - Whether the component should be displayed
 * @returns {JSX.Element} The rendered component
 */
export default function LoanProcessingStatusOld({
  alreadySubmitted = false,
  showMessage = false,
}) {
  if (!showMessage) {
    return null;
  }
  return (
    <Grid item xs={12}>
      {alreadySubmitted ? (
        <Grid item xs={12}>
          <Typography
            color="textColor"
            variant="subtitle1"
            sx={{ textAlign: "left" }}
          >
            Loan Application Already Submitted
          </Typography>
        </Grid>
      ) : (
        <Grid item xs={12}>
          <Typography
            color="textColor"
            variant="subtitle1"
            sx={{ textAlign: "left" }}
          >
            Loan Application in Progress
          </Typography>
        </Grid>
      )}
      <Grid item sx={{ textAlign: "left" }} xs={10}>
        <Typography color="textColor" variant="body1" sx={{ pt: 2 }}>
          Thank you for completing your Loan Application. We have received your
          application. Now sit back and relax. We will process your loan
          application and get back to you to complete remaining journey. *
        </Typography>
      </Grid>
    </Grid>
  );
}
